import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test-ref": "submit-forgot-username-failed-alert"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "mr-1" }
const _hoisted_6 = {
  key: 1,
  "data-test-ref": "submit-forgot-username-twin-alert"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  "data-test-ref": "submit-forgot-username-invalid-alert"
}
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_14 = {
  key: 3,
  "data-test-ref": "submit-forgot-username-multipleSSN-alert"
}
const _hoisted_15 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_18 = {
  key: 4,
  "data-test-ref": "submit-forgot-username-userNotFound-alert"
}
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "mr-1" }
const _hoisted_23 = {
  key: 5,
  "data-test-ref": "submit-forgot-username-subscriberError-alert"
}
const _hoisted_24 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "mr-1" }
const _hoisted_28 = {
  key: 6,
  "data-test-ref": "submit-forgot-username-system-alert"
}
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_32 = {
  key: 7,
  "data-test-ref": "submit-forgot-username-id-or-ssn-required-alert"
}
const _hoisted_33 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_36 = { class: "mr-1" }
const _hoisted_37 = {
  key: 8,
  "data-test-ref": "submit-forgot-username-both-id-and-ssn-alert"
}
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_41 = { class: "mr-1" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "flex-grow-1 w-100 mb-3" }
const _hoisted_44 = ["id", "title"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "fas fa-question-circle",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  "data-test-ref": "member-id-valid-message",
  class: "text-danger mt-0"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "invisible" }
const _hoisted_52 = { class: "flex-grow-0 fs-4 mx-5" }
const _hoisted_53 = { class: "flex-grow-1 w-100 mb-3" }
const _hoisted_54 = ["title"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", {
  class: "fas fa-question-circle",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 0,
  "data-test-ref": "ssn-valid-message",
  class: "text-danger mt-0"
}
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "invisible" }
const _hoisted_61 = { class: "d-flex align-items-center" }
const _hoisted_62 = { class: "flex-grow-1 w-100 mb-3" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  key: 0,
  "data-test-ref": "dob-required-message",
  class: "text-danger mt-0"
}
const _hoisted_65 = {
  key: 1,
  "data-test-ref": "dob-valid-message",
  class: "text-danger mt-0"
}
const _hoisted_66 = {
  key: 1,
  class: "mt-0 fs-sm text-secondary"
}
const _hoisted_67 = { class: "invisible flex-grow-0 fs-4 mx-5" }
const _hoisted_68 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_69 = { class: "flex-grow-1 w-100 mb-3" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 0,
  "data-test-ref": "firstName-required-message",
  class: "text-danger mt-0"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "invisible" }
const _hoisted_74 = { class: "invisible flex-grow-0 fs-4 mx-5" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_76 = { class: "d-flex justify-content-between my-4" }
const _hoisted_77 = {
  class: "d-flex align-items-center",
  "data-test-ref": "member-forgot-username-tech-support"
}
const _hoisted_78 = ["href"]

import FaqModal from '@/components/common/faq-modal.vue';
import { useI18n, createNamespacedT } from '@/i18n';
import { computed, ref } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { BFormInput } from 'bootstrap-vue';
import { formatPhoneNumber } from '@/utils/format';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { dateFormat } from 'commercial-web-client-utilities';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';
import { AxiosError } from 'axios';
import { useSiteConfig } from '@/composables/site-config';
import { createMemberProfileRecoveryService, SecureLinkOptions } from '@/composables/profile-recovery-service';
import { useForgotUsernameValidations } from '@/composables/forgot-username-validations';
import { LoginHelpErrorCodes } from '@/enums/forgot-username-error-codes';
import { useAppStore, useLoginHelpStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'info-form',
  emits: ['updateRoute'],
  setup(__props, { emit }) {

const i18n = useI18n();
const ledsService = useLedsService();
const siteConfig = useSiteConfig();
const appStore = useAppStore();
const loginHelpStore = useLoginHelpStore();
const uuid = uuidv4();
const nonsecureService = useNonsecureService();
const forgotUsernameValidations = useForgotUsernameValidations();
const tNamespace = 'forgotUsername';
const tns = createNamespacedT(i18n, tNamespace);
const profileRecoveryService = createMemberProfileRecoveryService({
    ledsService,
    nonsecureService,
});

const showNoMatchingMemberError = ref(false);
const showMemberIdOrSSNRequiredError = ref(false);
const showFaqModal = ref(false);
const showTwinError = ref(false);
const showNetworkError = ref(false);
const showInfoNoMatch = ref<boolean>(false);
const showInfoInvalidError = ref<boolean>(false);
const showInValidSSN = ref<boolean>(false);
const showUserNotFound = ref<boolean>(false);
const loading = ref(false);

const formattedPhoneNumber = computed(() => formatPhoneNumber(tns('techSupport.phoneNumber')));

const memberIdTooltipImageUrl = computed(() => {
    return loginHelpStore.aemAssets.idCardMemberIdHighlight;
});



async function submit() {
    const validForm = await forgotUsernameValidations.v$.value.$validate();
    showMemberIdOrSSNRequiredError.value = forgotUsernameValidations.errors.value.memberIdOrSSNRequired !== null;
    if (validForm) {
        loading.value = true;
        const firstName = forgotUsernameValidations.state.firstName;

        try {
            const request = forgotUsernameValidations.state.ssn.length > 0
                ? {
                    withSocialSecurityNumber: {
                        socialSecurityNumber: forgotUsernameValidations.state.ssn.replaceAll('-', ''),
                        dateOfBirth: dateFormat(forgotUsernameValidations.state.dob, 'YYYY-MM-DD'),
                        ...(firstName.length > 0 && { firstName }),
                    }
                }
                : {
                    withIdCardNumber: {
                        idCardNumber: forgotUsernameValidations.state.memberId,
                        dateOfBirth: dateFormat(forgotUsernameValidations.state.dob, 'YYYY-MM-DD'),
                        ...(firstName.length > 0 && { firstName }),
                    },
                } as SecureLinkOptions;

            const res = await profileRecoveryService.secureLink(request);
            if (res.data.emailDomain) emit('updateRoute', 'email');
            return res;
        } catch (err) {
            logger.log(err);
            resetErrorAlerts();
            switch ((err as AxiosError).response?.status) {
                case LoginHelpErrorCodes.MULTIPLE_MATCHES_ERROR:
                    forgotUsernameValidations.firstNameRequired.value = true;
                    showTwinError.value = true;
                    break;
                case LoginHelpErrorCodes.REQUESTED_SUBSCRIBER_ERROR:
                case LoginHelpErrorCodes.MEMBER_NOT_FOUND_ERROR:
                    showUserNotFound.value = true;
                    break;
                case LoginHelpErrorCodes.COVERAGE_INFO_INVALID_ERROR:
                    showInfoInvalidError.value = true;
                    break;
                case LoginHelpErrorCodes.DEPENDENTS_UNDERAGE_ERROR:
                    showInfoNoMatch.value = true;
                    break;
                case LoginHelpErrorCodes.MULTIPLE_COVERAGES_ERROR:
                    showInValidSSN.value = true;
                    break;
                default:
                    showNetworkError.value = true;
                    break;
            }
        } finally {
            loading.value = false;
        }
    }
}

const resetErrorAlerts = () => {
    showNetworkError.value = false;
    showTwinError.value = false;
    showInfoNoMatch.value = false;
    showNoMatchingMemberError.value = false;
    showInfoInvalidError.value = false;
    showInValidSSN.value = false;
    showUserNotFound.value = false;
};


const navigateToLogin = () => {
    window.location.href = appStore.logoutUrl ?? '';
};

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_popover = _resolveComponent("b-popover")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_datepicker = _resolveComponent("b-form-datepicker")!
  const _component_b_input_group_append = _resolveComponent("b-input-group-append")!
  const _component_b_input_group = _resolveComponent("b-input-group")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _directive_b_tooltip_position_fix = _resolveDirective("b-tooltip-position-fix")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (showNoMatchingMemberError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_alert, {
              variant: "warning",
              show: showNoMatchingMemberError.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_i18n_t, {
                        keypath: "forgotUsername.infoForm.alerts.noMatchingMember",
                        tag: "span"
                      }, {
                        frequentlyAskedQuestions: _withCtx(() => [
                          _createVNode(_component_b_link, {
                            "data-test-ref": "member-forgot-username-faq-link",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (showFaqModal.value = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(tns)('infoForm.alerts.frequentlyAskedQuestions')), 1 /* TEXT */)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"])
          ]))
        : (showTwinError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_b_alert, {
                variant: "warning",
                show: showTwinError.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_unref(tns)('infoForm.alerts.requiredFirstNameAlert', {
                            firstNameLabel: _unref(tns)('infoForm.firstName.label')
                        })), 1 /* TEXT */)
                    ])
                  ])
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["show"])
            ]))
          : (showInfoInvalidError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_b_alert, {
                  variant: "warning",
                  show: showInfoInvalidError.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_unref(tns)('infoForm.alerts.coverageInfoInvalidError')), 1 /* TEXT */)
                      ])
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["show"])
              ]))
            : (showInValidSSN.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_b_alert, {
                    variant: "warning",
                    show: showInValidSSN.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(_unref(tns)('infoForm.alerts.multipleSSN')), 1 /* TEXT */)
                        ])
                      ])
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["show"])
                ]))
              : (showUserNotFound.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_b_alert, {
                      variant: "warning",
                      show: showUserNotFound.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_i18n_t, {
                                keypath: "forgotUsername.infoForm.alerts.userNotFound",
                                tag: "span"
                              }, {
                                frequentlyAskedQuestions: _withCtx(() => [
                                  _createVNode(_component_b_link, {
                                    "data-test-ref": "member-forgot-username-faq-link",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showFaqModal.value = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(tns)('infoForm.alerts.frequentlyAskedQuestions')), 1 /* TEXT */)
                                    ], undefined, true),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ])
                        ])
                      ], undefined, true),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show"])
                  ]))
                : (showInfoNoMatch.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_b_alert, {
                        variant: "warning",
                        show: showInfoNoMatch.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_i18n_t, {
                                  keypath: "forgotUsername.infoForm.alerts.requestedSubscriberError",
                                  tag: "span"
                                }, {
                                  frequentlyAskedQuestions: _withCtx(() => [
                                    _createVNode(_component_b_link, {
                                      "data-test-ref": "member-forgot-username-faq-link",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showFaqModal.value = true))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(tns)('infoForm.alerts.frequentlyAskedQuestions')), 1 /* TEXT */)
                                      ], undefined, true),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ])
                          ])
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["show"])
                    ]))
                  : (showNetworkError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_b_alert, {
                          variant: "danger",
                          show: showNetworkError.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(_unref(tns)('infoForm.alerts.systemError')), 1 /* TEXT */)
                              ])
                            ])
                          ], undefined, true),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["show"])
                      ]))
                    : (showMemberIdOrSSNRequiredError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_b_alert, {
                            variant: "danger",
                            show: showMemberIdOrSSNRequiredError.value
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _hoisted_35,
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.memberIdOrSSNRequired.required), 1 /* TEXT */)
                                ])
                              ])
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["show"])
                        ]))
                      : (_unref(forgotUsernameValidations).errors.value.bothMemberIdAndSSNInput)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createVNode(_component_b_alert, {
                              variant: "danger",
                              show: true
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.bothMemberIdAndSSNInput.valid), 1 /* TEXT */)
                                  ])
                                ])
                              ], undefined, true),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true),
      _createElementVNode("p", null, _toDisplayString(_unref(tns)('infoForm.subtext')), 1 /* TEXT */),
      _createVNode(_component_b_overlay, {
        show: loading.value,
        rounded: "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            "data-test-ref": "forgot-username-form",
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (submit()), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_b_form_group, {
                  description: _unref(tns)('infoForm.idCard.subLabel'),
                  class: "flex-grow-1 w-100 mb-0"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('infoForm.idCard.label')) + " ", 1 /* TEXT */),
                    _createElementVNode("a", {
                      id: _unref(uuid) + '-id-card-number-tooltip-trigger',
                      href: "javascript:void(0)",
                      class: "ml-1",
                      tabindex: "-1",
                      title: _unref(tns)('infoForm.idCard.tooltip')
                    }, _hoisted_46, 8 /* PROPS */, _hoisted_44),
                    _createVNode(_component_b_popover, {
                      target: _unref(uuid) + '-id-card-number-tooltip-trigger',
                      triggers: "focus hover",
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(memberIdTooltipImageUrl),
                          alt: _unref(tns)('infoForm.idCard.imageAltText'),
                          class: "w-100"
                        }, null, 8 /* PROPS */, _hoisted_47)
                      ], undefined, true),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["target"])
                  ]),
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_unref(BFormInput), {
                      id: "member-id-input",
                      modelValue: _unref(forgotUsernameValidations).state.memberId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(forgotUsernameValidations).state.memberId) = $event)),
                      trim: "",
                      "data-test-ref": "member-id-input-field",
                      state: _unref(forgotUsernameValidations).validateState('memberId'),
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(forgotUsernameValidations).v$.value.memberId.$touch()))
                    }, null, 8 /* PROPS */, ["modelValue", "state"]), [
                      [_directive_b_tooltip_position_fix, {
                                    id: _unref(uuid) + '-id-card-tooltip',
                                    placement: 'bottomleft',
                                }]
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["description"]),
                (_unref(forgotUsernameValidations).v$.value.memberId.$dirty
                                && _unref(forgotUsernameValidations).v$.value.memberId.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_unref(forgotUsernameValidations).errors.value.memberIdValid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.memberId.valid), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.memberId.valid), 1 /* TEXT */)
                    ]))
              ]),
              _createElementVNode("h4", _hoisted_52, _toDisplayString(_unref(tns)('common.or')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_b_form_group, {
                  description: _unref(tns)('infoForm.ssn.subLabel'),
                  class: "flex-grow-1 w-100 mb-0"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('infoForm.ssn.label')) + " ", 1 /* TEXT */),
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: "javascript:void(0)",
                      class: "ml-1",
                      tabindex: "-1",
                      title: _unref(tns)('infoForm.ssn.tooltip')
                    }, _hoisted_56, 8 /* PROPS */, _hoisted_54)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        {
                          focus: true,
                          hover: true,
                          right: true
                        }
                      ]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_unref(BFormInput), {
                      id: "member-ssn-input",
                      modelValue: _unref(forgotUsernameValidations).state.ssn,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(forgotUsernameValidations).state.ssn) = $event)),
                      "data-test-ref": "ssn-input-field",
                      "data-maska": "###-##-####",
                      state: _unref(forgotUsernameValidations).validateState('ssn'),
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (_unref(forgotUsernameValidations).v$.value.ssn.$touch()))
                    }, null, 8 /* PROPS */, ["modelValue", "state"]), [
                      [_directive_maska]
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["description"]),
                (_unref(forgotUsernameValidations).v$.value.ssn.$dirty
                                && _unref(forgotUsernameValidations).v$.value.ssn.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      (_unref(forgotUsernameValidations).errors.value.ssnValid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.ssn.valid), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.ssn.valid), 1 /* TEXT */)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_b_form_group, {
                  label: _unref(tns)('infoForm.dob.label'),
                  class: "flex-grow-1 w-100 mb-0",
                  state: _unref(forgotUsernameValidations).validateState('dob')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_input_group, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_unref(BFormInput), {
                          id: "member-dob-input",
                          modelValue: _unref(forgotUsernameValidations).state.dob,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(forgotUsernameValidations).state.dob) = $event)),
                          "data-test-ref": "dob-input-field",
                          state: _unref(forgotUsernameValidations).validateState('dob'),
                          "data-maska": "##/##/####",
                          type: "text",
                          autocomplete: "off",
                          trim: "",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_unref(forgotUsernameValidations).syncDob()))
                        }, null, 8 /* PROPS */, ["modelValue", "state"]), [
                          [_directive_maska]
                        ]),
                        _createVNode(_component_b_input_group_append, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_datepicker, {
                              modelValue: _unref(forgotUsernameValidations).dobDp,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(forgotUsernameValidations).dobDp) = $event)),
                              "button-only": "",
                              right: "",
                              locale: "en",
                              "show-decade-nav": true,
                              max: new Date(),
                              "value-as-date": true,
                              "button-variant": "outline-primary",
                              "nav-button-variant": "primary",
                              "data-test-ref": "date-of-birth-datepicker",
                              onContext: _unref(forgotUsernameValidations).onDobContextChange
                            }, null, 8 /* PROPS */, ["modelValue", "max", "onContext"])
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ], undefined, true),
                      _: 1 /* STABLE */
                    })
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "state"]),
                (_unref(forgotUsernameValidations).v$.value.dob.$dirty
                                && _unref(forgotUsernameValidations).v$.value.dob.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      (_unref(forgotUsernameValidations).errors.value.dobRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.dob.required), 1 /* TEXT */))
                        : (_unref(forgotUsernameValidations).errors.value.dobInvalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.dob.valid), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_unref(tns)('infoForm.dob.subLabel')), 1 /* TEXT */))
              ]),
              _createElementVNode("h4", _hoisted_67, _toDisplayString(_unref(tns)('common.or')), 1 /* TEXT */),
              _createVNode(_component_b_form_group, { class: "flex-grow-1 w-100" })
            ]),
            (_unref(forgotUsernameValidations).firstNameRequired.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_b_form_group, {
                      label: _unref(tns)('infoForm.firstName.label'),
                      class: "flex-grow-1 w-100 mb-0",
                      state: _unref(forgotUsernameValidations).validateState('firstName')
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_unref(BFormInput), {
                          id: "member-firstName-input",
                          modelValue: _unref(forgotUsernameValidations).state.firstName,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(forgotUsernameValidations).state.firstName) = $event)),
                          "data-test-ref": "firstName-input-field",
                          state: _unref(forgotUsernameValidations).validateState('firstName'),
                          type: "text",
                          autocomplete: "off",
                          trim: ""
                        }, null, 8 /* PROPS */, ["modelValue", "state"]), [
                          [_directive_maska]
                        ])
                      ], undefined, true),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "state"]),
                    (_unref(forgotUsernameValidations).v$.value.firstName.$dirty
                                && _unref(forgotUsernameValidations).v$.value.firstName.$invalid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          (_unref(forgotUsernameValidations).errors.value.firstNameRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.firstName.required), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(forgotUsernameValidations).errorMessages.firstName.required), 1 /* TEXT */)
                        ]))
                  ]),
                  _createElementVNode("h4", _hoisted_74, _toDisplayString(_unref(tns)('common.or')), 1 /* TEXT */),
                  _createVNode(_component_b_form_group, { class: "flex-grow-1 w-100" })
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_75,
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_b_link, { onClick: navigateToLogin }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(tns)('common.cancel')), 1 /* TEXT */)
                ], undefined, true),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_button, {
                variant: "primary",
                disabled: _unref(forgotUsernameValidations).errors.value.bothMemberIdAndSSNInput,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(tns)('common.continue')), 1 /* TEXT */)
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ])
          ], 32 /* HYDRATE_EVENTS */)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createElementVNode("div", _hoisted_77, [
        _createVNode(_component_i18n_t, {
          keypath: "forgotUsername.techSupport.havingTrouble",
          tag: "p",
          scope: "global"
        }, {
          visitSupport: _withCtx(() => [
            _createVNode(_component_b_link, {
              "data-test-ref": "member-forgot-username-technical-support",
              target: "_blank",
              onClick: _unref(siteConfig).redirectToTechSupport
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(tns)('techSupport.visitSupport')), 1 /* TEXT */)
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          phoneNumber: _withCtx(() => [
            _createElementVNode("a", {
              href: `tel:${_unref(formattedPhoneNumber)}`,
              "data-test-ref": "member-mfa-phone-number"
            }, _toDisplayString(_unref(formattedPhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_78)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(FaqModal, {
      id: "faqModal",
      modelValue: showFaqModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showFaqModal).value = $event)),
      "test-ref": 'forgot-username',
      "hide-footer": true
    }, null, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})